import React from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isNil from 'lodash/isNil';
import FormFeedback from 'components/ui/form/form_feedback';
import { useI18n } from 'hooks/use_i18n';
import classname from 'classnames';

const FormFieldError = ({ meta, className }) => {
  const { t } = useI18n();

  if (!meta.touched) {
    return null;
  }

  const { error } = meta;

  if (!error) {
    return null;
  }

  const checkError = (err) => {
    if (isObject(err) && !isNil(err.t)) {
      return t(err.t, err.params);
    }
    return err;
  };

  const getErrors = () => {
    if (isArray(error)) {
      return error.map(checkError).join(', ');
    }
    if (isObject(error)) {
      return checkError(error);
    }
    return error;
  };

  return (
    <FormFeedback className={classname('form-field-error', className)}>
      <span dangerouslySetInnerHTML={{ __html: getErrors() }} />
    </FormFeedback>
  );
};

FormFieldError.defaultProps = {
  meta: {
    error: null,
    touched: false,
  },
  className: '',
};

FormFieldError.propTypes = {
  meta: PropTypes.object,
  className: PropTypes.string,
};

export default FormFieldError;
